(function()
{
    document.querySelectorAll('[data-stepper]').forEach(root=>{
        const items = [...root.querySelectorAll('.stepper__item')];
        const prev  = root.querySelector('[data-stepper-prev]');
        const next  = root.querySelector('[data-stepper-next]');
        let idx = Math.max(0, items.findIndex(i => i.classList.contains('stepper__item--active')));
        if (idx < 0) idx = 0;

        function paint()
        {
            items.forEach((it,i)=>
            {
                it.classList.toggle('stepper__item--active', i===idx);
                it.classList.toggle('stepper__item--done',   i<idx);
            });
        }
        paint();

        prev?.addEventListener('click', ()=>{ idx = Math.max(0, idx-1); paint(); });
        next?.addEventListener('click', ()=>{ idx = Math.min(items.length-1, idx+1); paint(); });

        items.forEach((it,i)=>it.addEventListener('click', ()=>{ idx = i; paint(); }));
    });
})();
